export function isElementBelowViewport(element, offset = 0) {
  if (!element) {
    return false;
  }

  const { top } = element.getBoundingClientRect();
  return top + offset >= window.innerHeight;
}
